var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllus3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2002 14.1975C3.2002 13.2033 4.00608 12.3975 5.0002 12.3975H14.0002C14.9943 12.3975 15.8002 13.2033 15.8002 14.1975V20.1975C15.8002 21.1916 14.9943 21.9975 14.0002 21.9975H5.0002C4.00608 21.9975 3.2002 21.1916 3.2002 20.1975V14.1975ZM5.0002 13.9975C4.88974 13.9975 4.8002 14.087 4.8002 14.1975V20.1975C4.8002 20.3079 4.88974 20.3975 5.0002 20.3975H14.0002C14.1107 20.3975 14.2002 20.3079 14.2002 20.1975V14.1975C14.2002 14.087 14.1107 13.9975 14.0002 13.9975H5.0002Z",
    fill: "#FF6C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2002 14.1975C19.2002 13.2033 20.0061 12.3975 21.0002 12.3975H30.0002C30.9943 12.3975 31.8002 13.2033 31.8002 14.1975V20.1975C31.8002 21.1916 30.9943 21.9975 30.0002 21.9975H21.0002C20.0061 21.9975 19.2002 21.1916 19.2002 20.1975V14.1975ZM21.0002 13.9975C20.8897 13.9975 20.8002 14.087 20.8002 14.1975V20.1975C20.8002 20.3079 20.8897 20.3975 21.0002 20.3975H30.0002C30.1107 20.3975 30.2002 20.3079 30.2002 20.1975V14.1975C30.2002 14.087 30.1107 13.9975 30.0002 13.9975H21.0002Z",
    fill: "#FF6C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00098 45.8002V44.2002H26V45.8002H5.00098Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00098 33.8065V32.2065H57.015V33.8065H5.00098Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7516 9.27477L50.7518 28.429L47.8585 21.4197L42.6445 39.4556L40.0516 34.5632L38.2334 41.9687L36.6793 41.9675L33.7557 29.9817L31.0885 27.5418L25.6099 39.0272L22.6183 34.0099L18.0201 43.3742L15.0651 38.9688L11.1397 47.578H7.51672L4.73969 54.3054L3.26074 53.6949L6.44622 45.978H10.1107L14.7979 35.6982L17.8053 40.1817L22.4821 30.6572L25.453 35.6398L30.5745 24.903L35.1948 29.1297L37.459 38.4124L39.4989 30.1038L42.2059 35.2114L47.5919 16.5806L50.6611 24.0158L56.2488 8.72559L57.7516 9.27477Z",
    fill: "url(#paint0_linear_2_5236)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_5236",
    x1: 57.0002,
    y1: 54.0002,
    x2: 17.4309,
    y2: 54.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6C00",
    stopOpacity: 0.21
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllus3);
export default __webpack_public_path__ + "static/media/illus3.6bb47de911a2991466aababc599117ba.svg";
export { ForwardRef as ReactComponent };